import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { VimoTaskContent } from '../../../common/components';

class TaskInfo extends React.Component {
    render() {
        const {
            taskData,
        } = this.props;

        return taskData ? (
            <VimoTaskContent
                task={taskData}
            />
        ) : null;
    }
}

TaskInfo.propTypes = {
    taskData: PropTypes.object,
};

TaskInfo.defaultProps = {
    taskData: null,
};

const mapStateToProps = (state, ownProps) => ({
    taskData: state.program.taskDetails && state.program.taskDetails[ownProps.taskId],
});

export default connect(mapStateToProps)(TaskInfo);
